import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16, IcoTrash16 } from '@onefootprint/icons';
import { Button, Divider, Form, IconButton, type TemplateInputProps } from '@onefootprint/ui';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ExternalApiFormData } from '../../../../types';
type ParametersProps = {
  fieldName: 'config.headers' | 'config.queryParams' | 'config.sandboxHttpProperties.headers' | 'config.sandboxHttpProperties.queryParams';
  title: string;
  disabled?: boolean;
  autocompleteItems: TemplateInputProps['autocompleteItems'];
};
const Parameters = t0 => {
  const $ = _c(49);
  const {
    fieldName,
    title,
    disabled: t1,
    autocompleteItems
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "externalApi.requestConfig.parameters"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  const {
    control
  } = useFormContext();
  const t3 = control || undefined;
  let t4;
  if ($[1] !== fieldName || $[2] !== t3) {
    t4 = {
      control: t3,
      name: fieldName
    };
    $[1] = fieldName;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    fields: headerFields,
    append,
    remove
  } = useFieldArray(t4);
  let t5;
  if ($[4] !== append) {
    t5 = () => {
      append({
        key: "",
        value: ""
      });
    };
    $[4] = append;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleAddProperty = t5;
  let t6;
  if ($[6] !== title) {
    t6 = <div className="text-label-2 text-primary">{title}</div>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <span className="text-body-2 text-tertiary">{t7}</span>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t) {
    t9 = t(_temp2);
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <span className="text-body-2 text-tertiary">{t9}</span>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="w-8" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t8) {
    t12 = <div className="grid grid-cols-[1fr_1fr_auto] gap-4 items-center">{t8}{t10}{t11} </div>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Divider />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== autocompleteItems || $[22] !== disabled || $[23] !== fieldName || $[24] !== headerFields || $[25] !== remove || $[26] !== t) {
    let t15;
    if ($[28] !== autocompleteItems || $[29] !== disabled || $[30] !== fieldName || $[31] !== remove || $[32] !== t) {
      t15 = (field, index) => <div key={field.id} className="grid grid-cols-[1fr_1fr_auto] gap-4"><Form.Input name={`${fieldName}.${index}.key`} placeholder={t(_temp3)} className="w-full font-mono" size="compact" disabled={disabled} /><Form.TemplateInput name={`${fieldName}.${index}.value`} placeholder={t(_temp4)} disabled={disabled} autocompleteItems={autocompleteItems} size="compact" /><IconButton icon={IcoTrash16} size="compact" variant="ghost" disabled={disabled} destructive={true} onClick={() => remove(index)} aria-label={t(_temp5)} /></div>;
      $[28] = autocompleteItems;
      $[29] = disabled;
      $[30] = fieldName;
      $[31] = remove;
      $[32] = t;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    t14 = headerFields.map(t15);
    $[21] = autocompleteItems;
    $[22] = disabled;
    $[23] = fieldName;
    $[24] = headerFields;
    $[25] = remove;
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14) {
    t15 = <div className="flex flex-col gap-3">{t12}{t13}{t14}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t(_temp6);
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== disabled || $[40] !== handleAddProperty || $[41] !== t16) {
    t17 = <div><Button disabled={disabled} fullWidth={false} variant="secondary" size="compact" prefixIcon={IcoPlusSmall16} onClick={handleAddProperty}>{t16}</Button></div>;
    $[39] = disabled;
    $[40] = handleAddProperty;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t15 || $[44] !== t17) {
    t18 = <div className="flex flex-col gap-4 p-3 border border-tertiary rounded-md">{t15}{t17}</div>;
    $[43] = t15;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t18 || $[47] !== t6) {
    t19 = <div className="flex flex-col gap-3">{t6}{t18}</div>;
    $[46] = t18;
    $[47] = t6;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
};
export default Parameters;
function _temp($) {
  return $.key;
}
function _temp2($_0) {
  return $_0.value;
}
function _temp3($_1) {
  return $_1.key;
}
function _temp4($_2) {
  return $_2.value;
}
function _temp5($_3) {
  return $_3.remove;
}
function _temp6($_4) {
  return $_4.add;
}